'use client';

import 'components/product-ui/variables.css';
import { ChevronRight } from '@doist/icons/brand';
import { Box, Button } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { ContainerTwoColumns } from 'components/container-two-column/container-two-column';
import { KarmaScene } from 'components/product-ui/scenes/karma';
import { TextLockUp } from 'components/text-lock-up/text-lock-up';
import { useLocale } from 'next-intl';
import css from './two-column-section.module.css';
function TwoColumnSection() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'karma');
  return <ContainerTwoColumns width="base" data-sentry-element="ContainerTwoColumns" data-sentry-component="TwoColumnSection" data-sentry-source-file="two-column-section.tsx">
            <ContainerTwoColumns.BodyContainer className={css.textColumn} data-sentry-element="unknown" data-sentry-source-file="two-column-section.tsx">
                <TextLockUp title={t('demo.title')} size="base" buttons={[<Button key="1" bleed variant="tertiary" endIcon={ChevronRight} href="/help/articles/introduction-to-karma-OgWkWy">
                            {t('demo.cta')}
                        </Button>]} data-sentry-element="TextLockUp" data-sentry-source-file="two-column-section.tsx">
                    {t('demo.description')}
                </TextLockUp>
            </ContainerTwoColumns.BodyContainer>
            <Box className={css.sceneColumn} data-sentry-element="Box" data-sentry-source-file="two-column-section.tsx">
                <KarmaScene data-sentry-element="KarmaScene" data-sentry-source-file="two-column-section.tsx" />
            </Box>
        </ContainerTwoColumns>;
}
export { TwoColumnSection };